/* global axios */
import ApiClient from '../ApiClient';

class WhatsappChannel extends ApiClient {
  constructor() {
    super('whatsapp', { accountScoped: true });
  }

  createEmbeddedSignup(params) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, params);
  }

  reauthorizeWhatsApp({ inboxId, ...params }) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, {
      ...params,
      inbox_id: inboxId,
    });
  }

  createQrConnection(provider) {
    return axios.post(`${this.baseUrl()}/whatsapp/qr_connections`, {
      provider,
    });
  }

  getQrConnectionStatus(provider, id) {
    return axios.get(`${this.baseUrl()}/whatsapp/qr_connections/${id}`, {
      params: { provider },
    });
  }
}

export default new WhatsappChannel();
